/** Video debug: console.log only when enabled (for admins). */
let enabled = false;
export function setVideoDebugEnabled(value: boolean) {
  enabled = value;
}
export function videoDebugLog(tag: string, data: unknown) {
  if (!enabled) return;
  try {
    console.log("[video-debug]", tag, data);
  } catch (_) {}
}

/** Hex (ordinary tile) debug: when admin or ?hex_debug=1 */
let hexEnabled = false;
export function setHexDebugEnabled(value: boolean) {
  hexEnabled = value;
}
export function hexDebugLog(tag: string, data: unknown) {
  if (!hexEnabled) return;
  try {
    console.log("[hex-debug]", tag, data);
  } catch (_) {}
}
export function isHexDebugEnabled(): boolean {
  return hexEnabled;
}
